import { render, staticRenderFns } from "./WhatIsCepa.vue?vue&type=template&id=134ec0c5&scoped=true"
import script from "./WhatIsCepa.vue?vue&type=script&lang=js"
export * from "./WhatIsCepa.vue?vue&type=script&lang=js"
import style0 from "./WhatIsCepa.vue?vue&type=style&index=0&id=134ec0c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ec0c5",
  null
  
)

export default component.exports